import type { ThemeConfig } from "antd"

/**
 * The app-wide antd theme, set once in the root ConfigProvider (index.tsx).
 * The brand cyan replaces antd's default blue on every primary control
 * (buttons, switches, tabs, links, checkboxes, focus rings), and antd buttons
 * take the 28px compact look of the toolbar's primary button, so antd buttons
 * and the hand-made ones (styles/buttonTokens.css) are one style. Feature
 * ConfigProviders nest inside it and inherit these values; they must not set
 * their own colorPrimary or button tokens.
 */
export const DATAQ_THEME: ThemeConfig = {
  token: {
    colorPrimary: "#36C3ED",
    colorLink: "#36C3ED",
  },
  components: {
    Button: {
      controlHeight: 28,
      controlHeightSM: 28,
      fontSize: 12,
      fontWeight: 600,
      borderRadius: 6,
      paddingInline: 12,
      paddingInlineSM: 12,
      // The gap between a button's icon and its text (--dq-btn-gap); the
      // icons inside buttons carry no margins of their own.
      iconGap: 6,
      defaultBorderColor: "#D1D5DB",
      defaultBg: "#FFFFFF",
      colorPrimaryHover: "#1FB3DF",
    },
  },
}
